<template>
  <div class="policy">
    <div class="flex items-center justify-between">
      <CTitle title="政策文件"></CTitle>
      <div class="more" @click="onClickMore">
        查看更多
        <img src="@/assets/img/performance/more.svg" alt="">
      </div>
    </div>
    <div class="policy-content">
      <div class="policy-list flex justify-between items-center" v-for="(item,index) in list" :key="item.id" @click="gotoDetail(item,index)">
        <div class="policy-name">{{ item.title }}</div>
        <div class="policy-time">{{ item.publishDate }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import CTitle from "@/components/Title/index.vue";
import {queryByLimit} from "@/api";

export default {
  name: "performancePolicy",
  components: {CTitle},
  data() {
    return {
      list: []
    }
  },
  mounted() {
    this.getPolicyList()
  },
  methods: {
    getPolicyList() {
      let _this = this
      this.list = []
      queryByLimit({
        applicationScenario: "10",
        articletype: "1",
        pageIndex: 0,
        type: "sbgx"
      }).then(res => {
        let data = res.result.data
        if (data != null && data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            if (i <= 7) {
              _this.list.push(data[i])
            }
          }
        }
      })
    },
    onClickMore() {
      this.$router.push({
        path: "/performance/list",
        query: {
          type: 1
        }
      })
    },
    gotoDetail(item, index) {
      this.$router.push({
        path: "/policy/detail",
        query: {
          id: item.id,
          action: 1
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.policy {
  width: 880px;
  height: 493px;
  background: #FFFFFF;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.0715);
  padding: 40px;

  .more {
    font-size: 14px;
    line-height: 28px;
    color: #666666;
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      margin-left: 6px;
    }
  }

  .policy-content {
    margin-top: 30px;

    .policy-list {
      height: 44px;
      border-bottom: 1px dashed #D8D8D8;
      cursor: pointer;

      &:hover {
        .policy-name {
          color: #1D52D9;
        }
      }

      .policy-name {
        width: 600px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .policy-time {
        font-size: 16px;
        font-weight: normal;
        line-height: 45px;
        color: #999999;
      }
    }
  }
}
</style>
